module.exports = __webpack_public_path__ + "img/lw-logo-peak.ed5011eb.png";